import type Highcharts from "highcharts";

declare module "highcharts" {
  interface ChartEventsOptions {
    pointClick?: (this: Highcharts.Point, e: Highcharts.PointClickEventObject) => void;
  }
}

export default function pointClickChartEvent(H: typeof Highcharts) {
  H.addEvent(
    H.Point,
    "click",
    function (this: Highcharts.Point, e: Highcharts.PointClickEventObject) {
      H.fireEvent(this.series.chart, "pointClick", e);
    },
  );
}
